import { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import validator from 'validator';
import { Typography } from '../../typography';
import { Button } from '../../button';
import { Input, InputPhoneNumber } from '../../input';
import { Select } from '../../select';
import {
  ModalBase,
  ModalWrapper,
  ModalFooterButtons,
  ModalBodyCustomColumns,
} from '../ModalComponents';
import { getPhoneNumberValue } from '../../../utils';
import {
  tableDotsActions,
  gateAllTableDotsActions,
  containerTypes,
  INPUT_ERRORS,
  REGEX,
  containerConditionOptions,
} from '../../../const';
import { i18n } from '../../../i18n';

export const gateModal: any = {};

export const ConfirmModal = () => {
  const [open, setOpen] = useState(false);
  const [containerNumber, setContainerNumber] = useState('');
  const [containerType, setContainerType] = useState('');
  const [condition, setCondition] = useState('');
  const [driverFirstName, setDriverFirstName] = useState('');
  const [driverLastName, setDriverLastName] = useState('');
  const [licensePlateNumber, setLicensePlateNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [authorizedLicensePlateNumbers, setAuthorizedLicensePlateNumbers] = useState([]);
  const [comment, setComment] = useState('');

  const [, setUpdate] = useState<any>();

  const validators = {
    driverFirstName:
      !!driverFirstName &&
      (!validator.isLength(driverFirstName, { max: 30 }) || !REGEX.USER_NAME.test(driverFirstName))
        ? INPUT_ERRORS.NOT_VALID.DRIVER_NAME
        : '',
    driverLastName:
      !!driverLastName &&
      (!validator.isLength(driverLastName, { max: 30 }) || !REGEX.USER_NAME.test(driverLastName))
        ? INPUT_ERRORS.NOT_VALID.DRIVER_NAME
        : '',
    licensePlateNumber: licensePlateNumber
      ? !validator.isLength(licensePlateNumber, { min: 4, max: 10 })
        ? INPUT_ERRORS.NOT_VALID.LICENSE_PLATE_NUMBER_LENGTH
        : !REGEX.LICENSE_PLATE_NUMBER.test(licensePlateNumber)
        ? INPUT_ERRORS.NOT_VALID.LICENSE_PLATE_NUMBER
        : ''
      : '',
    phoneNumber: phoneNumber
      ? !isValidPhoneNumber(`+${getPhoneNumberValue(phoneNumber)}`)
        ? INPUT_ERRORS.NOT_VALID.PHONE_NUMBER
        : ''
      : '',
    comment: comment
      ? !validator.isLength(comment, { min: 10, max: 200 })
        ? INPUT_ERRORS.NOT_VALID.COMMENT_LENGTH
        : ''
      : '',
  };
  if (gateModal.type === 'GATE_OUT') {
    validators.licensePlateNumber = !validator.isLength(licensePlateNumber, {
      min: 4,
      max: 10,
    })
      ? INPUT_ERRORS.NOT_VALID.LICENSE_PLATE_NUMBER_LENGTH
      : !REGEX.LICENSE_PLATE_NUMBER.test(licensePlateNumber)
      ? INPUT_ERRORS.NOT_VALID.LICENSE_PLATE_NUMBER
      : '';
    validators.driverFirstName = !String(driverFirstName).length
      ? INPUT_ERRORS.REQUIRED.DRIVER_NAME
      : !validator.isLength(driverFirstName, { max: 30 })
      ? INPUT_ERRORS.NOT_VALID.USERNAME_LENGTH
      : !REGEX.USER_NAME.test(driverFirstName)
      ? INPUT_ERRORS.NOT_VALID.DRIVER_NAME
      : '';
    validators.driverLastName = !String(driverLastName).length
      ? INPUT_ERRORS.REQUIRED.DRIVER_NAME
      : !validator.isLength(driverLastName, { max: 30 })
      ? INPUT_ERRORS.NOT_VALID.USERNAME_LENGTH
      : !REGEX.USER_NAME.test(driverLastName)
      ? INPUT_ERRORS.NOT_VALID.DRIVER_NAME
      : '';

    if (gateModal.type === 'GATE_OUT' && gateModal.action === 'loaded') {
      validators.driverFirstName = '';
      validators.driverLastName = '';
    }
  }

  useEffect(() => {
    gateModal.open = () => {
      const action = [...tableDotsActions, ...gateAllTableDotsActions].find(
        (obj) => obj.value === gateModal.val,
      );
      gateModal.actionLabel = action?.label;
      gateModal.action = action?.value;
      gateModal.name = `${action?.label} ${gateModal.containerNumber}`;
      gateModal.isSubmitClicked = false;

      if (gateModal.type === 'GATE_IN') {
        setContainerType(gateModal.containerType);
        setCondition(gateModal.condition || '');
        setDriverFirstName(gateModal.driverFirstName || '');
        setDriverLastName(gateModal.driverLastName || '');
        setLicensePlateNumber(gateModal.licensePlateNumber || '');
        if (gateModal.phoneNumber) setPhoneNumber(gateModal.phoneNumber);
      }
      if (gateModal.type === 'GATE_OUT' && gateModal.action === 'edit') {
        setDriverFirstName(gateModal.driverFirstName || '');
        setDriverLastName(gateModal.driverLastName || '');
        setLicensePlateNumber(gateModal.licensePlateNumber || '');
      }
      if (
        gateModal.type === 'GATE_OUT' &&
        (gateModal.action === 'complete' || gateModal.action === 'loaded')
      ) {
        setContainerNumber(gateModal.containerNumber);
        setContainerType(gateModal.containerType);
        setDriverFirstName(gateModal.driverFirstName || '');
        setDriverLastName(gateModal.driverLastName || '');
        setLicensePlateNumber(gateModal.licensePlateNumber || '');
        if (gateModal.phoneNumber) setPhoneNumber(gateModal.phoneNumber);
        setAuthorizedLicensePlateNumbers(gateModal.authorizedLicensePlateNumbers || []);
        setComment(gateModal.comment || '');
      }

      if (gateModal.type !== '') setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(gateModal).forEach((key) => {
      if (key !== 'open') delete gateModal[key];
    });
    setOpen(!open);
  };

  const handleCompleteClick = () => {
    if (gateModal.action !== 'complete' && gateModal.action !== 'loaded') return true;

    gateModal.isSubmitClicked = true;
    setUpdate(Math.random());

    const otherProps: any = {};
    let otherBool = false;
    if (gateModal.type === 'GATE_IN') {
      otherProps.containerType = containerType;
      otherBool = !containerType;
    }
    if (
      gateModal.type === 'GATE_OUT' &&
      (gateModal.action === 'complete' || gateModal.action === 'loaded')
    ) {
      otherProps.licensePlateNumber = licensePlateNumber;
      otherBool = !licensePlateNumber;
    }

    if (
      gateModal.type === 'GATE_IN' ||
      (gateModal.type === 'GATE_OUT' &&
        (gateModal.action === 'complete' || gateModal.action === 'loaded'))
    ) {
      if (!driverFirstName || !driverLastName || !licensePlateNumber || !phoneNumber || otherBool) {
        const props: any = {
          ...otherProps,
        };

        const messages = Object.keys(props)
          .filter((key: any) => !props[key])
          .map((key) => `${key} is required`)
          .join('\n');
        if (messages) return;
      }
      if ([...Object.values(validators).map((val) => !val)].some((val) => !val)) {
        return;
      }

      gateModal.type = '';
      gateModal.containerNumber = containerNumber;
      gateModal.containerType = containerType;
      gateModal.condition = condition;
      gateModal.driverFirstName = driverFirstName;
      gateModal.driverLastName = driverLastName;
      gateModal.licensePlateNumber = licensePlateNumber;
      gateModal.phoneNumber = getPhoneNumberValue(phoneNumber);
      gateModal.comment = comment;
    }

    return true;
  };

  const handleSubmitClick = async (printAfterComplete = false) => {
    const isValid = handleCompleteClick();
    if (!isValid) return;

    await gateModal.fc(printAfterComplete);
    gateModal.isSubmitClicked = false;
    setOpen(false);
  };

  return (
    <ModalBase id={'confirm-universal-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.gateTitle', { action: gateModal.name })}
        </Typography>
        {open &&
          (gateModal.type === 'GATE_IN' || gateModal.type === 'GATE_OUT') &&
          (gateModal.action === 'complete' || gateModal.action === 'loaded') && (
            <>
              {gateModal.type === 'GATE_OUT' && (
                <Select
                  label={i18n.t('label.allowedLicensePlateNumbers') + '*'}
                  options={authorizedLicensePlateNumbers}
                  value={licensePlateNumber}
                  onChange={(e) => setLicensePlateNumber(e.target.value)}
                />
              )}
              {gateModal.type === 'GATE_IN' && (
                <ModalBodyCustomColumns columns={'1fr 1fr'}>
                  <Select
                    label={i18n.t('label.containerType') + '*'}
                    options={containerTypes}
                    value={containerType}
                    onChange={(e) => {
                      setContainerType(e.target.value);
                    }}
                    error={gateModal.isSubmitClicked && !containerType}
                    helperText={
                      gateModal.isSubmitClicked &&
                      !containerType &&
                      INPUT_ERRORS.REQUIRED.CONTAINER_TYPE
                    }
                  />
                  <Select
                    label={i18n.t('label.condition')}
                    options={containerConditionOptions}
                    value={condition}
                    onSelect={(value: any) => setCondition(value)}
                  />
                </ModalBodyCustomColumns>
              )}
              {gateModal.action !== 'loaded' && (
                <>
                  <ModalBodyCustomColumns columns={'1fr 1fr'}>
                    <Input
                      label={
                        i18n.t('label.driverFirstName') + (gateModal.type === 'GATE_OUT' ? '*' : '')
                      }
                      data-size={'medium'}
                      defaultValue={driverFirstName}
                      onChange={(e) => setDriverFirstName(e.target.value)}
                      error={gateModal.isSubmitClicked && !!validators.driverFirstName}
                      helperText={gateModal.isSubmitClicked ? validators.driverFirstName : ''}
                    />
                    <Input
                      label={
                        i18n.t('label.driverLastName') + (gateModal.type === 'GATE_OUT' ? '*' : '')
                      }
                      data-size={'medium'}
                      defaultValue={driverLastName}
                      onChange={(e) => setDriverLastName(e.target.value)}
                      error={gateModal.isSubmitClicked && !!validators.driverLastName}
                      helperText={gateModal.isSubmitClicked ? validators.driverLastName : ''}
                    />
                  </ModalBodyCustomColumns>
                  <InputPhoneNumber
                    label={i18n.t('label.driverPhoneNumber')}
                    data-size={'medium'}
                    value={phoneNumber}
                    defaultValue={'+998'}
                    defaultCountry={'UZ'}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    error={!!validators.phoneNumber}
                    helperText={validators.phoneNumber}
                  />
                </>
              )}
              {gateModal.type === 'GATE_IN' && (
                <Input
                  label={i18n.t('label.licensePlateNumber')}
                  data-size={'medium'}
                  defaultValue={licensePlateNumber}
                  onChange={(e) => setLicensePlateNumber(e.target.value)}
                  error={!!validators.licensePlateNumber}
                  helperText={validators.licensePlateNumber}
                />
              )}
              {gateModal.type === 'GATE_OUT' && gateModal.action !== 'loaded' && (
                <Input
                  label={i18n.t('label.comment')}
                  data-size={'medium'}
                  defaultValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                  error={!!validators.comment}
                  helperText={validators.comment}
                />
              )}
            </>
          )}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          {gateModal.action === 'complete' && (
            <Button size={'medium'} data-color={'primary'} onClick={() => handleSubmitClick(true)}>
              {i18n.t('button.completeAndPrint')}
            </Button>
          )}
          <Button size={'medium'} data-color={'primary'} onClick={() => handleSubmitClick()}>
            {gateModal.actionLabel}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
